import { notifications } from "@mantine/notifications";
import { getApiErrorMessage } from "@utils/submissionUtils";

export const releaseErrorMessage = (error: unknown) => getApiErrorMessage(error, String(error));

export const notifyError = (error: unknown) =>
  notifications.show({ color: "red", message: releaseErrorMessage(error) });
